import { ComponentProps } from "react";
import {
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalFooter,
  ModalHeader,
} from "@/components/elements/Modal";
import { ConnectorOption } from "@/features/connectors";
import { IntegrationLogoBox } from "@/integrations";
import { Dialog } from "@headlessui/react";

export function ConnectorRequiresAdminDialog({
  option,
  onClose,
  ...dialogProps
}: {
  option: ConnectorOption;
  onClose: () => void;
} & ComponentProps<typeof Modal>) {
  const name = option.label;

  return (
    <Modal onClose={onClose} {...dialogProps}>
      <ModalHeader className="flex items-center justify-start gap-4">
        <IntegrationLogoBox id={option.value} size="sm" />
        <Dialog.Title className="text-lg">
          Admin Access Required for {name}
        </Dialog.Title>
      </ModalHeader>
      <ModalCloseButton />
      <ModalBody className="flex flex-col gap-4">
        <p className="text-sm">
          To create connections for {name}, you need admin privileges. Please
          contact your admin to proceed.
        </p>
      </ModalBody>
      <ModalFooter></ModalFooter>
    </Modal>
  );
}
